/**
 * author: Ananthapadmanabhan V K
 */
import React, { useContext, useEffect, useState } from "react";
import {
  Dropdown,
  Nav,
  Navbar,
  OverlayTrigger,
  Popover
} from "react-bootstrap";
import { useTranslation, withTranslation } from "react-i18next";
import { BiHelpCircle, BiMenu, BiPlus, BiUser, BiX, BiLinkExternal } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { CompanyInfoContext, PollerContext, PreferenceContext, SidebarContext } from "../../../App";
import ThemesToggleBox from "../../../ThemesToggle";
import { AIReportJobStatus, CWD_ID, LS_ACTIVE_ASSESSMENT_LIST_KEY, LS_AUTHORITY_KEY, LS_COMPANY_INFO_KEY, LS_UI_ELEMENTS_CONFIG_KEY, LS_ACCESS_TOKEN_KEY, PollerAction, PollerType, USER_ROLE } from "../../../core/constants/common";
import useRegulationHelper from "../../../core/hooks/useRegulationHelper";
import CompanyService from "../../../core/service/CompanyService";
import LogoutService from "../../../core/service/LogoutService";
import ProfileSettingsService from "../../../core/service/ProfileSettingsService";
import ReportAIService from "../../../core/service/ReportAIService";
import ReportService from "../../../core/service/ReportService";
import PermissionUtils from "../../../core/utilities/PermissisonUtils";
import Utils from "../../../core/utilities/Utils";
import { create_dce } from "../../Common/Forms/CreateDataCollectionEvent/CreateDataCollectionEvent";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import NewReportModal from "../Reporting/NewReportModal";
import useHasPermission from "../../../core/hooks/useHasPermission";
import { encryptString, decryptString } from "../../../core/utilities/stringCrypto";
import { hasGoalsKpiNavAccess } from "../GoalsAndKpi/utils/goalsAndKpiNavAccess";
import { buildHierarchyPermissions } from "../GoalsAndKpi/utils/hierarchyPermissions";
import "./Header.scss";
let poller;


const Header = ({ t }) => {
  // var langChoosed = 'en';
  const [userType, setUserType] = useState("");
  const { companyInfo, setCompanyInfo } = useContext(CompanyInfoContext);
  const [imgFile, setImgFile] = useState("");
  const navigate = useNavigate();
  const { k, i18n } = useTranslation();
  const [lsUserData, setLsUserData] = useState(null);
  const { sidebarDisplay, setSidebarDisplay } = useContext(SidebarContext);
  const [newReportModalDisplay, setNewReportDisplay] = useState(false);
  const { pollerData, setPollerData } = useContext(PollerContext);
  const uiElementsConfig = JSON.parse(localStorage.getItem(LS_UI_ELEMENTS_CONFIG_KEY)) ?? null;
  const lsSelfValue = localStorage.getItem(LS_ACTIVE_ASSESSMENT_LIST_KEY);
  const selfAssessment = lsSelfValue ? lsSelfValue === 'self' : true;
  const {
    getCompanyStandards,
    getSupplierRegulations,
  } = useRegulationHelper();
  const { preference, setPreference } = useContext(PreferenceContext);
  const [langChoosed, setLangChoosed] = useState([]);
  const [selectedLang, setSelectedLang] = useState();
  const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);

  const switchLanguage = (langCode, langName) => {
    setSelectedLang(langName);
    i18n.changeLanguage(langCode);
    setPreference({ language: langCode });
    localStorage.setItem('languageSelected', JSON.stringify({ code: langCode, name: langName }));
  };
  const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const companyId = lsData?.profile?.company?.id;
  const { hasGRIViewPermission,hasBRSRViewPermission,hasCSRViewPermission,hasVSMEViewPermission,hasGHGReportViewPermission } = useHasPermission();
  // TEMPORARY: same Goals & KPI nav check used to hide the rest of the app chrome. Revisit soon.
  const restrictNavToGoalsKpi = hasGoalsKpiNavAccess(
    buildHierarchyPermissions(Array.isArray(lsData?.roles) ? lsData.roles : [])
  );

  useEffect(() => {
    localStorage.setItem('languageAvailable', false)
    if (lsData.roles.includes("SUPPLIER_ADMIN")) {
      setUserType("SUPPLIER_ADMIN");
    }
    companyId && getCompanyDetails(companyId);

    // if (companyId > 0 && PermissionUtils.hasCompanyAdminPermission(lsData.roles)) {
    if (hasGRIViewPermission()||hasBRSRViewPermission()||hasCSRViewPermission()||hasVSMEViewPermission()||hasGHGReportViewPermission()) {
      fetchActiveReportGenerationJobForCompany();
    }

    getCompanyLanguages();
  }, []);

  useEffect(() => {
    const lsUserDat = localStorage.getItem('userOnboardData');
    if (lsUserDat !== "") {
      setLsUserData(JSON.parse(lsUserDat));
    }
  }, [localStorage.getItem('userOnboardData')]);

  useEffect(() => {
    if (PermissionUtils.isSupplierAdmin(lsData.roles)) {
      getSupplierRegulations();
    } else {
      getCompanyStandards();
    }
  }, []);

  useEffect(() => {
    if (preference.hasLanguagesChosen) {
      getCompanyLanguages();
    }
  }, [preference.hasLanguagesChosen]);

  const getCompanyLanguages = () => {
    CompanyService.getCompanyLanguageList()
      .then((response) => {
        if (response.status === 200) {
          if (response.data && response.data.length > 0) {
            localStorage.setItem('languageAvailable', true);
          }
          setLangChoosed([...response.data]);

          let selectedLanguage = JSON.parse(localStorage.getItem('languageSelected'));

          if (!selectedLanguage) {
            const primaryLanguage = response.data.find(lang => lang.primary === true);
            selectedLanguage = { code: primaryLanguage?.code ?? 'en', name: primaryLanguage?.name ?? 'English' };

            localStorage.setItem('primaryLanguage', selectedLanguage.code);
          }

          i18n.changeLanguage(selectedLanguage.code);
          setSelectedLang(selectedLanguage.name);

          if (!preference.language) {
            setPreference({ language: selectedLanguage.code });
          }
        }
      })
      .catch((error) => { });
  }

  const getCompanyDetails = async (companyId) => {
    setImgFile(ProfileSettingsService.getProfileImg(companyId));
    ProfileSettingsService.getCompanyDetails(companyId)
      .then((response) => {
        setCompanyInfo(response.data);
        localStorage.setItem(LS_COMPANY_INFO_KEY, JSON.stringify(response.data) ?? '{}');
      })
      .catch((error) => {
      });
  };
  var profileData = null;
  if (lsData !== "") {
    profileData = lsData?.profile?.user;
  }



  const logout = () => {
    LogoutService.logout()
      .then((response) => {
        clearCWDID();
        setPollerData({
          action: PollerAction.STOP,
          companyId: companyId,
          type: PollerType.REPORT_BUILDER,
          jobId: 0,
          status: '',
          progress: ''
        });
        const currentTheme = localStorage.getItem('theme') || 'light';
        localStorage.clear();
        localStorage.setItem('theme', currentTheme);
        document.documentElement.setAttribute('data-theme', currentTheme);
        navigate("/login");
      })
      .catch((error) => {
        clearCWDID();
        setPollerData({
          action: PollerAction.STOP,
          companyId: companyId,
          type: PollerType.REPORT_BUILDER,
          jobId: 0,
          status: '',
          progress: ''
        });
        const currentTheme = localStorage.getItem('theme') || 'light';
        localStorage.clear();
        localStorage.setItem('theme', currentTheme);
        document.documentElement.setAttribute('data-theme', currentTheme);
        navigate("/login");
        console.log("err", error);
      });
  };
  const Energyproduced_tooltip = (
    <Popover id="popover-trigger-hover-focus" className="p-2">
      <div className="p-1">
        {t("HelpAndSupport.label")}
      </div>

    </Popover>
  );

  const navigateToNewAssessment = () => {
    navigate(create_dce, { state: { selfAssessment } });
  };


  const fetchActiveReportGenerationJobForCompany = () => {
    ReportService.pollReportJOB().then(res => {
      if (res.status !== 200) return;

      const jobId = res.data?.id ?? 0;
      var reportType = "GRI"
      var jobType = res.data?.type ?? 'AUTO_DRAFT'
      if (!!res.data?.type && res.data?.type.indexOf("ESRS") !== -1) {
        reportType = "ESRS"
        jobType = "AUTO_DRAFT"
      }
      setPollerData({
        action: PollerAction.START,
        companyId: companyId,
        type: PollerType.REPORT_BUILDER,
        jobId: jobId,
        status: jobId > 0 ? AIReportJobStatus.IN_PROGRESS : '',
        progress: '',
        jobType: jobType,
        reportType: reportType,
      });
    }).catch(err => { })
  };
  const [isDark, setIsDark] = useState(false);
  const navigateToConsCompanySwitch = () => {
    navigate("/consultant/switch/");
  };

  const navigateToHomePage = () => {
    if (uiElementsConfig?.texts?.homePageURL) {
      window.location.href = uiElementsConfig?.texts?.homePageURL;
    } else {
      navigate('/company_admin/home');
    }
  };

  const renderCompanyLogo = () => {
    if (!companyId) return <></>;

    if (uiElementsConfig?.texts?.partnerLogoURL) {
      return <img src={uiElementsConfig?.texts?.partnerLogoURL} alt={companyInfo?.legalName} className="profileImg" />;
    } else {
      return <img src={imgFile} alt={companyInfo?.legalName} className="profileImg" />;
    }
  }

  const clearCWDID = () => {
    if (localStorage.getItem(CWD_ID)) {
      let passData = {
        cwd_id: localStorage.getItem(CWD_ID) ? localStorage.getItem(CWD_ID) : null
      }
      ReportAIService.clearCWDId(passData)
        .then(res => {
        })
        .catch((error) => {
        });
    }
  }

  const handleCloseReportGeneration = () => {
    setShowCloseConfirmation(true);
  };

  const handleConfirmCloseReportGeneration = (confirmed) => {
    setShowCloseConfirmation(false);
    if (confirmed) {
      // Call API to update job status to failed
      ReportService.updateJobStatus(pollerData.jobId, 3).then(res => {
        if (res.status !== 200) {
          console.error('Failed to update job status');
          return;
        }
        // Update poller data after successful API call
        setPollerData({
          ...pollerData,
          jobId: 0,
          action: PollerAction.STOP,
          status: AIReportJobStatus.FAILED,
          progress: ''
        });
      }).catch(err => {
        console.error('Error updating job status:', err);
        // Still update poller data even if API call fails
        setPollerData({
          ...pollerData,
          jobId: 0,
          action: PollerAction.STOP,
          status: AIReportJobStatus.FAILED,
          progress: ''
        });
      });
    }
  };

  const handleExternalLinkClick = async () => {
    const accessToken = localStorage.getItem(LS_ACCESS_TOKEN_KEY);
    if (accessToken) {
      const originalText = accessToken;
      const secretKey = 'z6vPr0GIxbqTBuq3wy1aHNVEtYKdqH5pVIAe';

      // Encrypt
      const encrypted = await encryptString(originalText, secretKey);
      // Decrypt
      // const decrypted = await decryptString(encrypted, secretKey);
      // console.log('Decrypted:', decrypted);
      const url = `https://support.ecodrisil.com/sso-redirect?payload=${encrypted}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      variant="light"
      className="Header"
      sticky="top"
    >
      <div className="Logo_MenuBox me-2">
        <Navbar.Brand href="" className="cursor HeadMenu_box" onClick={() => setSidebarDisplay(!sidebarDisplay)}>
          <BiMenu></BiMenu>
        </Navbar.Brand>
        <Navbar.Brand href="" className="cursor me-0  navbar_brandImg" onClick={() => navigateToHomePage()}>
          {renderCompanyLogo()}
        </Navbar.Brand>
      </div>
      <Navbar id="responsive-navbar-nav 1" className="ms-auto p-0">
        &nbsp;
        <Nav>
          {
            pollerData.type === PollerType.REPORT_BUILDER &&
            (pollerData.status === AIReportJobStatus.IN_PROGRESS || pollerData.status === AIReportJobStatus.NOT_STARTED) &&

            <span className="mx-2 Report_generatBox">
              <div className="spinner-8"></div>
              {t('BuildingReport.label')}
              <button
                className="ms-2 close-report-btn"
                onClick={handleCloseReportGeneration}
                title={t('Header.closeReportGeneration.label')}
                aria-label={t('Header.closeReportGeneration.label')}
              >
                <BiX style={{ fontSize: '16px' }} />
              </button>
            </span>
          }
          <div>
            <ThemesToggleBox />
          </div>
          {/* TEMPORARY: hide Quick Links when Goals & KPI nav access is present. Revisit soon. */}
          {!restrictNavToGoalsKpi && (
            <Dropdown>
              <Dropdown.Toggle variant="primary QuickLinks_btn" id="dropdown-basic">
                <BiPlus className="m-0" /><span> {t("QuickLinks.label")}</span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => navigateToNewAssessment()}>{t("NewDataCollectionEvent.label")}</Dropdown.Item>
                <Dropdown.Item
                  onClick={() => setNewReportDisplay(true)}>{t("NewReport.label")}</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
          {
            langChoosed.length > 0 &&
            <Dropdown className="dropright" id="dropdown-menu-align-end">
              <Dropdown.Toggle
                variant="drop1 nav-icon Language_drop_box"
                id="dropdown-basic"
              >
                {selectedLang}
              </Dropdown.Toggle>

              <Dropdown.Menu className="Language_menu_drop">
                <ul>
                  {
                    langChoosed?.map((lang, index) => (
                      <li className={`cursor ${selectedLang === lang.name ? "active" : ""}`}
                        key={index} onClick={() => switchLanguage(lang.code, lang.name)}>
                        <a value={lang.code}>
                          {lang.name}
                          {/* {lang.primary ? <BiCheck /> : null} */}
                        </a>
                      </li>
                    ))
                  }
                </ul>
              </Dropdown.Menu>
            </Dropdown>
          }
          {/* <Nav.Link href="#">
            <BiSearch />
          </Nav.Link> */}
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            overlay={
              <Popover id="popover-external-link" className="p-2">
                <div className="p-1">
                  Support
                </div>
              </Popover>
            }
          >
            <Nav.Link onClick={handleExternalLinkClick} style={{ cursor: 'pointer' }}>
              <BiHelpCircle />
            </Nav.Link>
          </OverlayTrigger>

          {/* <Nav.Link href="#">
            <BiBell />
          </Nav.Link> */}

          <Dropdown className="dropright" id="dropdown-menu-align-end">
            <Dropdown.Toggle
              variant="drop1 nav-icon Profile_navicon"
              id="dropdown-basic"
            >
              <div className="Userprofile_iconBox_header">
                {/* <BiUser /> */}
                <p className="initials-custom">
                  {Utils.nameInitials(profileData.name)}
                </p>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <div className="Header_dropdownbox short_profile-view">
                <ul>
                  <li>
                    <a href="#" className="short_profile-view_head">
                      <div className="Userprofile_iconBox_header">
                        <BiUser />
                      </div>
                      <h6 className="m-0">{profileData.name}</h6>
                    </a>
                  </li>
                  {
                    (!uiElementsConfig || uiElementsConfig?.hiddenModules?.indexOf('USER_PROFILE') < 0) &&
                    <>
                      {/* TEMPORARY: hide Profile Settings when Goals & KPI nav access is present. Revisit soon. */}
                      {!restrictNavToGoalsKpi && (
                        <li>
                          <a href="profile_settings">{t("ProfileDetails.label")}</a>
                        </li>
                      )}
                      {
                        // lsData?.roles?.includes(USER_ROLE.CONSULTANT) &&
                        PermissionUtils.isConsultant(lsData.roles) &&
                        <li>
                          <a href="#" onClick={() => navigateToConsCompanySwitch()}>{t("SwitchCompany.label")}</a>
                        </li>
                      }
                      <li>
                        <a href="#" onClick={logout}>
                          {t("Logout.label")}
                        </a>
                      </li>
                    </>
                  }
                </ul>
              </div>
            </Dropdown.Menu>
          </Dropdown>
          {/* <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
          </NavDropdown> */}
        </Nav>
        {
          newReportModalDisplay &&
          <NewReportModal onHide={() => setNewReportDisplay(false)} />
        }
        {
          showCloseConfirmation && (
            <ConfirmationModal
              modalShow={true}
              messageText={t('Header.closeReportGenerationConfirmation.label')}
              callbackModal={handleConfirmCloseReportGeneration}
              confirmBtn={t("Confirm.label")}
              CancelBtn={t("Cancel.label")}
            />
          )
        }

      </Navbar>
    </Navbar>
  );
};

export default withTranslation()(Header);
